import { Company } from '@tacliatech/types';

export const toolsStructure: Company.Tool[] = [
  {
    id: Company.IdTool.StopwatchWithPin,
    active: false,
    canAccess: false,
    path: '/admin/stopwatch-with-pin',
    icon: 'linear/key-alt',
  },
  {
    id: Company.IdTool.TpvApp,
    active: false,
    canAccess: false,
    path: '',
    icon: '',
  },
];

export const oldModuleStructure: Company.Module[] = [
  {
    id: Company.IdModule.Finals,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 1,
    canAccess: false,
    path: '/admin/contacts',
  },
  {
    id: Company.IdModule.ClockHours,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 2,
    canAccess: false,
    path: '/admin/clock-hours',
  },
  {
    id: Company.IdModule.Reports,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 3,
    canAccess: false,
    path: '/admin/reports?type=service',
  },
  {
    id: Company.IdModule.Deals,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 4,
    canAccess: false,
    path: '/admin/deals',
  },
  {
    id: Company.IdModule.Projects,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 5,
    canAccess: false,
    path: '/admin/projects',
  },
  {
    id: Company.IdModule.InternalVendors,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 6,
    canAccess: false,
    path: '/admin/contacts',
  },
  {
    id: Company.IdModule.Activities,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 7,
    canAccess: false,
    path: '/admin/activities',
  },
  {
    id: Company.IdModule.Expenses,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 8,
    canAccess: false,
    path: '/admin/expenses',
  },
  {
    id: Company.IdModule.Assets,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 9,
    canAccess: false,
    path: '/admin/address',
  },
  {
    id: Company.IdModule.Sales,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 10,
    canAccess: false,
    path: '/admin/budgets?type=BILL',
  },
  {
    id: Company.IdModule.Payments,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 11,
    canAccess: false,
    path: '/admin/payments',
  },
  {
    id: Company.IdModule.Equipments,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 12,
    canAccess: false,
    path: '/admin/equipments',
  },
  {
    id: Company.IdModule.Rates,
    payment: Company.ModulePaymentType.Free,
    active: true,
    index: 13,
    canAccess: false,
    path: '/admin/rates',
  },
];
